export const busiOptions = [
  { label: '按设备统计', value: 1 },
  { label: '按单位统计', value: 2 },
  { label: '按月度统计', value: 3 }
];

import { translateTo } from '@/utils/locale';

export const statOpDict = {
  undefined: () => {
    return {
      color: '#4EA8FF',
      seriesType: 'bar',
      op: {
        legend: { show: false },
        yAxis: { type: 'category' },
        xAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        series: [],
        dataset: {}
      }
    };
  },
  1: () => {
    // 分类总次数
    return {
      color: '#4EA8FF',
      seriesType: 'bar',
      op: {
        legend: { show: true, right: '5%', top: '1%', left: 'auto' },
        grid: {
          containLabel: true,
          left: '10%',
          right: '12%',
          top: '14%',
          bottom: '10%'
        },
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  2: () => {
    // 月度总次数
    return {
      color: '#4EA8FF',
      seriesType: 'bar',
      op: {
        legend: { show: true, right: '5%', top: '1%', left: 'auto' },
        grid: {
          containLabel: true,
          left: '10%',
          right: '12%',
          top: '14%',
          bottom: '10%'
        },
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  3: () => {
    // 报警：每时刻总次数 检测：按检测人统计
    return {
      color: '#4EA8FF',
      seriesType: 'bar',
      op: {
        legend: { show: true, right: '5%', top: '1%', left: 'auto' },
        grid: {
          containLabel: true,
          left: '10%',
          right: '12%',
          top: '14%',
          bottom: '10%'
        },
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  4: () => {
    // 报警：年度分类总次数 检测：按物质分类
    return {
      color: '#4EA8FF',
      seriesType: 'bar',
      op: {
        legend: { show: false },
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  11: () => {
    // 按设备统计
    return {
      color: '#4DDBB4',
      seriesType: 'bar',
      op: {
        legend: { show: false },
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  12: () => {
    // 按设备分类统计
    return {
      color: '#4DDBB4',
      seriesType: 'barStack',
      op: {
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  13: () => {
    // 单设备七天分类总次数
    return {
      color: '#4DDBB4',
      seriesType: 'bar',
      op: {
        legend: { show: false },
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  21: () => {
    // 按机构统计
    return {
      color: '#2BC9D0',
      seriesType: 'bar',
      op: {
        legend: { show: false },
        yAxis: { type: 'category' },
        xAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        series: [],
        dataset: {}
      }
    };
  },
  22: () => {
    // 按机构分类统计
    return {
      color: '#2BC9D0',
      seriesType: 'barStack',
      op: {
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  23: () => {
    // 按机构设备统计
    return {
      color: '#2BC9D0',
      seriesType: 'barStack',
      op: {
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  31: () => {
    // 按任务统计
    return {
      color: '#7743EA',
      seriesType: 'bar',
      op: {
        legend: { show: false },
        yAxis: { type: 'category' },
        xAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        series: [],
        dataset: {}
      }
    };
  },
  32: () => {
    // 按任务分类统计
    return {
      color: '#7743EA',
      seriesType: 'barStack',
      op: {
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  },
  33: () => {
    // 按任务统计
    return {
      color: '#7743EA',
      seriesType: 'barStack',
      op: {
        yAxis: { type: 'value', name: translateTo('次数', 'component.tableChart') },
        xAxis: { type: 'category' },
        series: [],
        dataset: {}
      }
    };
  }
};
